import { Modal } from "antd";
import parse from "html-react-parser";

const ViewResponseModal = ({
  title = "View Response",
  responseHtmlContent = "",
  isModalOpen = false,
  setIsModalOpen = () => {}
}) => {
  const reactElement = parse(responseHtmlContent);
  return (
    <Modal
      title={title}
      centered
      width={"1200px"}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <>{reactElement}</>
    </Modal>
  );
};
export default ViewResponseModal;
